export const HOVER_MENU_DELAY = {
  ENTER: 100,
  LEAVE: 1000
};
